<script lang="ts" setup>
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})
</script>

<template>
  <UPageError
    :status="props.error?.statusCode"
    name="Terjadi Kesalahan pada Server"
    message="Maaf, server kami mengalami kendala. Silakan coba lagi beberapa saat"
    :clear-button="{ label: 'Coba Lagi' }"
  />
</template>
